module.exports = __webpack_public_path__ + "img/NEOBUS.15fa34a5.svg";